import { getLocalizedPathnames } from '@module/mdrt-org/shared/i18n/get-localized-pathnames';
import prefetchPaths from '@module/mdrt-org/shared/utils/data/graphql/_generated/prefetch-paths.json';

const START_URL = '/';

export const getBusinessCriticalPathnames = (locales: string[]) =>
  getLocalizedPathnames([START_URL, ...prefetchPaths], locales);
